import gql from "graphql-tag";

export const tenantDetailsFragment = gql`
  fragment TenantDetailsFragment on Tenant {
    id
    legalName
    unitNo
    code
    leaseNo
    contractId
    tenantType
    description
    status
    operationStatus
    operationStartTime
    operationEndTime
    storeName
  }
`;
